import Swiper from "swiper/bundle";

let swiper = new Swiper(".mySwiper", {
    slidesPerView: "auto",
    initialSlide: 1,
    loop: true,
    autoplay: {
        delay: 3000,
    },
});